module.exports = __webpack_public_path__ + "images/help/icon-twr32-7b54a81b9a9bc3579c9af10022f20caa.png";